'use strict';
const _ = require('lodash');
const $ = require('jquery');
const Backbone = require('backbone');
const PubSub = require('../PubSub');
const template = require('../templates/video.ejs');
const slugify = require('slugify');

module.exports = Backbone.View.extend({
    className: 'view-video',
    events: {
        'click .btn-close': 'closeModal',
        'click .video-nav': 'routeNextVideo'
    },
    /**
     *
     */
    initialize: function (options) {
        _.bindAll(this, 'render');

        this.category = options.category;

        if(this.model.video_player == 'MTV' && this.model.video_url !== '') {
            $(window).on('resize', this.calculatePlayerSize.bind(this));
            this.listenTo(PubSub, 'resizeWindow', this.calculatePlayerSize.bind(this));
        }

        this.listenTo(PubSub, 'videoEnded', this.loadNextVideo.bind(this));
    },
    /**
     *
     */
    render: function () {
        var model = {
            video: this.model,
            category: this.category,
            video_order: parseInt(this.model.order,10)
        };
        this.$el.html(template(model));
        return this;
    },
    /**
     *
     */
    renderedToDom: function() {
        var player = this.$el.find('.video-player')[0];
        var video = player.getAttribute('data-contenturi');

        if(this.model.video_url == '') return;

        switch(this.model.video_player) {
            case 'MTV':
                player = this.$el.find('.mtv-video-player')[0];
                video = player.getAttribute('data-contenturi');

                PubSub.trigger('playVideo', video, player);
                $(window).resize();
                break;
            // case 'VEVO':
            //     PubSub.trigger('loadVEVO', video, this.model.id);
            //     break;
            // case 'YT':
            //     PubSub.trigger('loadYT', video, this.model.id);
            //     break;
            default:
                break;
        }
    },
    /**
     *
     */
    calculatePlayerSize: _.debounce(function() {
        if(_.isNull(this.model)) return;

        var video = this.$el.find('.pjs')[0];
        var height = $(video).height();
        var width = $(video).width();

        if(width == 0 || height == 0) return;

        video.setAttribute('data-aspect-ratio', height/width);
        video.removeAttribute('style');

        var updatedWidth = $(video).width();
        var updatedHeight = updatedWidth * video.getAttribute('data-aspect-ratio') + 'px';
        updatedWidth += 'px';

        var styleUpdate = "width: " + updatedWidth + "; height: " + updatedHeight;

        if(updatedWidth == '0px') {
            video.setAttribute('style', 'width: 100%; height: 100%;');
        } else {
            video.setAttribute('style', styleUpdate);
        }
    }, 100),
    /**
     *
     */
    routeNextVideo: function(e) {
        var target = e.currentTarget;
        var index = parseInt(this.model.order,10) - 1;
        var model = this.model;

        var previous = /(prev)/.test(target.className);

        if(previous) {
            model = this.category.get('voteData')[index - 1];
        } else {
            model = this.category.get('voteData')[index + 1]
        }


        var lowerCategoryName = this.category.get('name').toLowerCase();
        var lowerContestantName = model.name.toLowerCase();

        var omParams = {
            name: 'video_' + lowerCategoryName + '_' + lowerContestantName,
            section: slugify(this.category.get('name')), 
            url: window.location.href
        };
        var gaParams = {
            eventCategory: 'Button Click',
            eventAction: 'Watch Video : ' + this.category.get('name') + ' : ' + model.id
        };


        PubSub.trigger('loadVideo', model, this.category);
        PubSub.trigger('linkClick', omParams, gaParams);
    },
    /**
     *
     */
    loadNextVideo: function() {
        var index = parseInt(this.model.order,10) - 1;
        var model = this.category.get('voteData')[index + 1]
        if(model) {
            PubSub.trigger('loadVideo', model, this.category);
        }
    },
    /**
     *
     */
    closeModal: function(e) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        this.$el.removeClass('fade-in').addClass('fade-out');
        setTimeout(function() {
            PubSub.trigger('directRoute', 'closeCurrentModal');
        }, 175);
    },
    /**
     *
     */
    remove: function() {
        this.stopListening();
        this.off();
        PubSub.trigger('removeVideoPlayer', this.model.id);
        this.model = null;
        return Backbone.View.prototype.remove.call(this);
    }
});



// WEBPACK FOOTER //
// ./app/scripts/views/video.js